<h2 i18n><span>Ú</span>ltimos trabajos</h2>
<div id="works_container">
    <div appDisableOnMobile *ngFor="let work of works; let i = index"
        class="work_card" id="work_{{i}}"
        (click)="clickCard(i)"
        (keyup.enter)="clickCard(i)"
        tabindex="0"
        (mousemove)="onMouseMove($event, work_card)"
        (mouseleave)="onMouseLeave(work_card)"
        #work_card>
        <svg class="work_open" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
            <path fill="currentColor" d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"/>
        </svg>        
        <h3 class="work_title">{{work.title}}</h3>
        <div *ngIf="device === Device.Desktop && showImages" class="work_preview desktop_image" ><img  width="{{work.image_preview_width}}" height="{{work.image_preview_height}}" class="work_image photo--mask" src="{{work.image_preview}}" alt="{{work.title}}"></div>
        <div *ngIf="device === Device.Mobile && showImages" class="work_preview mobile_image"><img width="{{work.image_preview_mobile_width}}" height="{{work.image_preview_mobile_height}}" class="work_image photo--mask" src="{{work.image_preview_mobile}}" alt="{{work.title}}"></div>
    </div>
    <div #work_popup id="work_popup" class="" *ngIf="showPopup">
        <app-stars-background #starCanvas class="stars_background" [numberOfStars]="300"></app-stars-background> 
        <div appDisableSelection class="close_button_top_left close_work_popup" 
            (click)="closeSelected()"
            (keyup.enter)="closeSelected()"
            tabindex="0">X</div>
        <div appDisableSelection class="close_button_top_right close_work_popup" 
            (click)="closeSelected()"
            (keyup.enter)="closeSelected()"
            tabindex="0">X</div>
        <h3>{{selectedWork?.title}}</h3>
        <div><img class="photo--mask" src="{{selectedWork?.image}}" alt="{{selectedWork?.title}}" ></div>
        <div><a href="{{selectedWork?.url}}" target="_blank">{{selectedWork?.url}}</a></div>
        <div class="work_description"><p [innerHTML]="selectedWork?.description"></p></div>
        <div appDisableSelection class="close_button_bottom_left close_work_popup" 
            (click)="closeSelected()"
            (keyup.enter)="closeSelected()"
            tabindex="0">X</div>
        <div appDisableSelection class="close_button_bottom_right close_work_popup" 
            (click)="closeSelected()"
            (keyup.enter)="closeSelected()"
            tabindex="0">X</div>
    </div>
</div>